import { AssetType, ReleaseAssetProcessedOutcome } from '@peritasai/types';

export enum ReleaseToDeconStep {
  LOADING_LOCATIONS = 'loading-locations',
  SELECT_LOCATION = 'select-location',
  ERROR_LOCATIONS = 'error-locations',
  LOADING_HUB = 'loading-hub',
  HUB_OFFLINE = 'hub-offline',
  HUB_IN_USE = 'hub-in-use',
}

export enum ReleaseTrayStatus {
  PENDING = 'pending',
  RELEASED = 'released',
  NOOP = 'noop',
  FAILED = 'failed',
}

export type DetectedTray = {
  id: string;
  name: string;
  subtitle: string;
  assetType?: AssetType;
  detectedAtLabel: string;
  status: ReleaseTrayStatus | ReleaseAssetProcessedOutcome;
  caseId: string | null;
  timer: number;
};
